/**
 * Enable with: localStorage.setItem("integratorDebugAuth", "1") then refresh.
 * Disable: localStorage.removeItem("integratorDebugAuth")
 */
import { appendAuthTrace } from "./auth-trace";

const KEY = "integratorDebugAuth";

function enabled(): boolean {
  if (import.meta.env.DEV) return true;
  try {
    return window.localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function authLog(phase: string, payload: Record<string, unknown> = {}): void {
  const safe = { ...payload };
  for (const k of Object.keys(safe)) {
    if (/token|secret|password|key/i.test(k) && typeof safe[k] === "string") {
      const v = safe[k] as string;
      safe[k] = v.length > 0 ? `(${v.length} chars, redacted)` : "";
    }
  }
  appendAuthTrace(phase, safe);
  if (enabled()) {
    // Single-line JSON so the console and copied logs stay readable (not [object Object]).
    let line: string;
    try {
      line = `[integrator:auth] ${phase} ${JSON.stringify(safe)}`;
    } catch {
      line = `[integrator:auth] ${phase} (payload not serializable)`;
    }
    console.info(line);
  }
}
